import { useContext, useCallback } from 'react'
import { geoData, targetEnv as configTargetEnv } from '@fs/zion-config'
import axios from '@fs/zion-axios'
import JurisdictionsContext from '../context/JurisdictionsContext'
import JurisdictionsUpdateContext from '../context/JurisdictionsUpdateContext'

export default function useUpdateRussianJurisdiction() {
  const jurisdictions = useContext(JurisdictionsContext)
  const handleChangeJurisdictions = useContext(JurisdictionsUpdateContext)
  return useCallback(
    async (doesApply) => {
      const payload = [
        ...jurisdictions.filter((x) => x.jurisdiction !== 'RUSSIA'),
        { jurisdiction: 'RUSSIA', doesApply },
      ]
      if (doesApply && geoData?.country !== 'RU') {
        await logToRussia({ targetEnv: configTargetEnv, payload })
      }
      await handleChangeJurisdictions(payload)
      return jurisdictions?.find((x) => x.jurisdiction === 'RUSSIA')?.doesApply ?? null
    },
    [handleChangeJurisdictions, jurisdictions]
  )
}

export async function logToRussia({ targetEnv, payload }) {
  let subdomain = 'www'
  switch (targetEnv) {
    case 'local':
    case 'int':
      subdomain = 'integration'
      break
    case 'beta':
      subdomain = 'beta'
      break
    default:
      break
  }
  try {
    await axios.post(`https://${subdomain}-ru.familysearch.org/identity/register-api/ru-citizen`, payload)
  } catch (error) {
    // do nothing
  }
}
